import { render, staticRenderFns } from "./CenterPoint.vue?vue&type=template&id=298d3bfc&lang=pug&"
import script from "./CenterPoint.vue?vue&type=script&lang=ts&"
export * from "./CenterPoint.vue?vue&type=script&lang=ts&"
import style0 from "./CenterPoint.vue?vue&type=style&index=0&id=298d3bfc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports